import React from "react";
import { useFormContext } from "./FormContext";
import { FormErrorContainer } from "../FormErrorContainer";

interface FormFieldErrorsProps {
  apiErrors?: string[];
  fieldErrors?: { [k: string]: string[] };
}

const FormFieldErrors: React.FC<FormFieldErrorsProps> = ({
  apiErrors = [],
  fieldErrors = {},
}) => {
  const { validationResult, isSubmitted } = useFormContext();

  // Get all validation errors from form
  const validationErrors =
    isSubmitted && validationResult?.errorMessages
      ? validationResult.errorMessages
      : [];

  // Get all field errors from API
  const apiFieldErrors = Object.values(fieldErrors).flat();

  // Combine all errors, but avoid duplication
  // If we have field-specific errors, prioritize them over general apiErrors
  const hasFieldErrors = apiFieldErrors.length > 0;
  const allErrors = hasFieldErrors
    ? [...validationErrors, ...apiFieldErrors]
    : [...validationErrors, ...apiErrors];

  if (allErrors.length === 0) {
    return null;
  }

  return <FormErrorContainer errors={allErrors} style={{ marginTop: 24 }} />;
};

export default FormFieldErrors;
